import { Box, Card, Divider, ListItemText } from '@mui/material'
import { memo } from 'react'

import AvatarShape from '../../assets/illustrations/avatar-shape'
import ProviderIcon from '../shared/exchangeProviderCard/ProviderIcon'
import SocialStats from './SocialStats'

const ProfileStats = ({
  stats,
  statColumns,
  title,
  desc,
  banner,
  displayPic,
  displayPicSx,
  picSize = 100,
  additional
}) => {
  return (
    <Card sx={[{ textAlign: 'center' }]}>
      <Box sx={{ position: 'relative' }}>
        <AvatarShape
          sx={{
            left: 0,
            right: 0,
            zIndex: 10,
            mx: 'auto',
            bottom: -50,
            position: 'absolute'
          }}
        />

        <ProviderIcon
          sx={{
            left: 0,
            right: 0,
            zIndex: 11,
            mx: 'auto',
            bottom: -38,
            position: 'absolute',
            ...displayPicSx
          }}
          size={picSize}
          {...displayPic}
        />
        {banner}
      </Box>

      <ListItemText
        sx={{ mt: 6, mb: 1 }}
        primary={title}
        secondary={desc}
        slotProps={{
          primary: { sx: { typography: 'subtitle1' } },
          secondary: { sx: { mt: 0.5 } }
        }}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
      {stats && stats.length && (
        <SocialStats data={stats} columns={statColumns} />
      )}
      {additional}
    </Card>
  )
}

export default memo(ProfileStats)
